import request from '@/utils/request'

// const baseURL = process.env.VUE_APP_BASE_URL
// const prefix = '/patyee'

export function def(data) {
  return request({
    url: '/bus/tradePublicity',
    method: 'POST',
    data
  })
}

// 检索左侧导航栏的层级关系
export function getSideCompanyList(data) {
  return request({
    url: `/patyee/file/list/files`,
    method: 'POST',
    data
  })
}

// export function querySearch(data) {
//   return request({
//     url: `${prefix}/search/search`,
//     method: 'POST',
//     data
//   })
// }

export function querySearch(data) {
  return request({
    url: `/bus/competitorLibrary/competitorDatabaseSearch`,
    method: 'POST',
    data
  })
}

export function getCompanyList(companyName) {
  return request({
    url: `/bus/competitorLibrary/competitorDatabaseCount?title=${companyName || ''}`,
    method: 'GET'
  })
}
// 获取专利数据库的token
export function productDataBase() {
  return request({
    url: `/bus/productDataBase/productDataBase`,
    method: 'GET'
  })
}

// 获取一体化的token
export function geIntegrationToken() {
  return request({
    url: `bus/thematic/getIntegrationToken`,
    method: 'GET'
  })
}

// 深圳获取一体化token
export function geSZIntegrationToken() {
  return request({
    url: `bus/patyee/token`,
    method: 'GET'
  })
}
